import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('rect-round', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 6 6",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0H1C0.447715 0 0 0.447715 0 1V5C0 5.55228 0.447715 6 1 6H5C5.55228 6 6 5.55228 6 5V1C6 0.447715 5.55228 0 5 0Z",
    fill: props.colors[0]
  }));
});